import { Fragment } from 'react';
import classNames from 'classnames';
import { IconProgressBarItem } from './types';
import { AppNextLink } from '../app-next-link';
interface Props {
  items: IconProgressBarItem[];
  activeStep: number;
  className?: string;
}
export const IconProgressBar = ({
  items,
  activeStep = 1,
  className
}: Props) => {
  return <div className={classNames('flex [&_svg]:!h-6 [&_svg]:!w-6 [&_svg]:lg:!h-8 [&_svg]:lg:!w-8', className)} data-sentry-component="IconProgressBar" data-sentry-source-file="icon-progress-bar.tsx">
            {items.map(({
      icon,
      title,
      url
    }, index) => {
      const step = index + 1;
      const itemContent = <>
                        {icon}

                        {title && <span className='text-caption-12 font-medium lg:text-body-14'>{title}</span>}
                    </>;
      const itemContentClassName = classNames('flex flex-col items-center justify-center gap-0.5 [&>svg]:!h-6 [&>svg]:!w-6', {
        'text-primary-main': activeStep >= step,
        'text-primary-shade-200': activeStep < step
      });
      return <Fragment key={index}>
                        {step > activeStep ? <div className={itemContentClassName}>{itemContent}</div> : <AppNextLink prefetch={false} href={url} className={itemContentClassName}>
                                {itemContent}
                            </AppNextLink>}

                        {index !== items.length - 1 && <div className={classNames('mx-1 my-auto h-0.5 w-24 flex-1 rounded lg:w-36', {
          'bg-primary-main': activeStep > step,
          'bg-primary-shade-200': activeStep <= step
        })} />}
                    </Fragment>;
    })}
        </div>;
};